module.exports = __webpack_public_path__ + "static/media/payment.0b529d7d.svg";